const FILTER_STORAGE_TYPES = Object.freeze({
  LOCAL: 'local',
  SESSION: 'session',
  NONE: 'none',
});

export const FILTER_TYPES = Object.freeze({
  BOOLEAN: 'boolean',
  SINGLE: 'single',
  MULTI: 'multi',
});

export const FILTER_KEYS = Object.freeze({
  RESPONSIBLE_EMPLOYEE_ID: 'responsible_employee_id',
  MESSAGES_COUNT_NOT_EQ: 'messages_count_not_eq',
  CONTACT_ID: 'contact_id',
  CONTACT_TYPE: 'contact_type',
  PROJECT_ID: 'project_id',
  LEVEL_ID: 'level_id',
  LEVEL_TYPE: 'level_type',
  QUERY: 'query',
  STATUS: 'status',
  FOLLOWING: 'following',
  UNREAD: 'unread',
  MENTIONED: 'mentioned',
  UNIT_ID: 'unit_id',
  TICKET_CATEGORY_ID: 'ticket_category_id',
  RESPONSIBLE_ID: 'responsible_id',
  RESPONSIBLE_TYPE: 'responsible_type',
});

export const FILTER_SCOPES = Object.freeze({
  DOCUMENTS_OVERVIEW: 'documents_overview',
  DOCUMENTS_INFO: 'documents_info',
  DOCUMENTS_DECISIONS: 'documents_decisions',
  TICKETS_OVERVIEW: 'tickets_overview',
  TICKETS_ALL_PROJECTS: 'tickets_projects',
  TICKETS_PROJECT: 'tickets_project',
  TICKETS_EMAIL_CONVERSATIONS: 'tickets_email_conversations',
  TICKETS_ISSUE_LIST: 'tickets_issue_list',
  ISSUES_INBOX: 'issues_inbox',
  ISSUES_OVERVIEW: 'issues_overview',
  ISSUES_LEVEL: 'issues_level',
  TODOS_OVERVIEW: 'todos_overview',
  TODOS_LEVEL: 'todos_level',
  MILESTONE_UNITS_OVERVIEW: 'milestone_units_overview',
  MILESTONES_OVERVIEW: 'milestones_overview',
});

export default FILTER_STORAGE_TYPES;
